"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

export function FooterSurface({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const surface =
    pathname === "/" ||
    pathname === "/business" ||
    pathname === "/solutions" ||
    pathname === "/infrastructure" ||
    pathname === "/pricing" ||
    pathname === "/products" ||
    pathname.startsWith("/products/")
      ? "white"
      : "cream";

  return (
    <footer className="ec-footer ec-footer-lktech" data-surface={surface}>
      {children}
    </footer>
  );
}
